import React from 'react';
import { PropertyGroup } from './PropertyGroup';

/**
 * Heading tag property component
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HeadingTagProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  if (field.type !== 'heading') {
    return null;
  }
  return /*#__PURE__*/_jsx(PropertyGroup, {
    label: "Heading Tag",
    children: /*#__PURE__*/_jsxs("select", {
      value: field.headingTag || 'h3',
      onChange: e => updateField(selectedField, {
        headingTag: e.target.value
      }),
      className: "property-input",
      children: [/*#__PURE__*/_jsx("option", {
        value: "h1",
        children: "H1"
      }), /*#__PURE__*/_jsx("option", {
        value: "h2",
        children: "H2"
      }), /*#__PURE__*/_jsx("option", {
        value: "h3",
        children: "H3"
      }), /*#__PURE__*/_jsx("option", {
        value: "h4",
        children: "H4"
      }), /*#__PURE__*/_jsx("option", {
        value: "h5",
        children: "H5"
      }), /*#__PURE__*/_jsx("option", {
        value: "h6",
        children: "H6"
      })]
    })
  });
};